import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import { IcLock16Icon } from '@gem/icons';

import { IconView, IconViewSizes } from '../IconView/IconView';
import styles from './BaseAvatar.styles.m.css';
import { IBaseAvatarProps } from './BaseAvatar.types';

export * from './BaseAvatar.types';

export const BaseAvatar: FC<PropsWithChildren<IBaseAvatarProps>> = (props) => {
  const { className, children, type, isOnline = false, hasLockIcon, badge } = props;

  const BadgeIcon = hasLockIcon ? IcLock16Icon : badge?.Icon;

  const badgeClassName = classNames(styles.badge, {
    [styles.badgeLock]: hasLockIcon,
  });

  const isShowBadge = !!BadgeIcon && (hasLockIcon || !isOnline);

  const containerClassName = classNames(styles.container, styles[type], className, {
    [styles.hasBadge]: isShowBadge,
  });

  return (
    <div className={containerClassName}>
      {children}
      {isOnline && !isShowBadge && <div className={styles.online} />}
      {isShowBadge && (
        <div className={badgeClassName}>
          <IconView
            className={styles.badgeIcon}
            Icon={BadgeIcon}
            size={IconViewSizes.Small}
          />
        </div>
      )}
    </div>
  );
};
